"use client";

import { useState, useEffect } from "react";

interface ScrollDirectionState {
  isScrollingUp: boolean;
  scrollY: number;
  isAtTop: boolean;
}

/**
 * Hook to detect scroll direction and position
 * Returns whether user is scrolling up, current scroll position, and if at top of page
 */
export function useScrollDirection(): ScrollDirectionState {
  const [state, setState] = useState<ScrollDirectionState>({
    isScrollingUp: false,
    scrollY: 0,
    isAtTop: true,
  });

  useEffect(() => {
    let lastScrollY = window.scrollY;
    let ticking = false;

    const updateScrollDirection = () => {
      const scrollY = window.scrollY;
      const isScrollingUp = scrollY < lastScrollY;
      const isAtTop = scrollY < 50;

      setState({
        isScrollingUp,
        scrollY,
        isAtTop,
      });

      lastScrollY = scrollY;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDirection);
        ticking = true;
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });

    // Initial check
    updateScrollDirection();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return state;
}
